/* eslint-disable jsx-a11y/label-has-associated-control */
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { Checkbox, CircularProgress, Typography } from '@mui/material';
import { IUpdateSolicitationInputModel, PaymentSolicitationUpdateInputModel } from 'inputModels';
import { serialize } from 'object-to-formdata';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { IPaymentSolicitationViewModel } from 'viewModels';
import { useForm, useWatch } from 'react-hook-form';
import { ReactComponent as IconDollar } from '../../../assets/icons/iconDollar.svg';
import { ReactComponent as IconPaperClip } from '../../../assets/icons/IconPaperclip.svg';
import { useSolicitation } from '../../../context/solicitation';
import { Download } from '../../../controller/FileController';
import { SolicitationController } from '../../../controller/SolicitationController';
import { ModalPaymentType, PaymentSolicitationStatus, ServiceStatus } from '../../../types/enums';
import { Attachment } from '../../Attachment';
import { Button } from '../../Buttons/Button';
import { CustomFile, DropZone } from '../../DropZone';
import { ContentModal, Header } from './styles';
import { usePayment } from '../../../context/payment';
import { useAlert } from '../../../hooks/useAlert';
// import Star from '../../StarAvaliation';

interface StatusPaymentProps {
  isOpen: boolean;
  onRequestClose: () => void;
  solicitationId?: string;
  selectedPayment?: IPaymentSolicitationViewModel;
  type: ModalPaymentType;
}
export function ModalStatusPayment({
  isOpen,
  selectedPayment,
  solicitationId,
  onRequestClose,
  type,
}: StatusPaymentProps) {
  const TIMER_LOADING = 300;
  const alert = useAlert();
  const { setPayments, refetchPayments } = usePayment();
  const { setSolicitations } = useSolicitation();
  const [statusPayment, setStatusPayment] = useState(
    selectedPayment?.paymentSolicitationStatus === PaymentSolicitationStatus.PAID,
  );
  const [attachment, setAttachment] = useState<CustomFile>();
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { control } = useForm({
    reValidateMode: 'onChange',
  });

  // const items: number[] = [...(new Array(5).keys() as any)];

  // const [activeIndex, setActiveIndex] = useState<number | undefined>();

  // const onClickStar = (starIndex: number) => {
  //   setActiveIndex((oldState) => (oldState === starIndex ? undefined : starIndex));
  // };

  useWatch({
    control,
    name: ['commentService', 'isIntegratedProtocol', 'integratedProtocolValue'],
  });
  const handleUpdateStatus = async () => {
    if (!attachment) return;

    const update: PaymentSolicitationUpdateInputModel = {
      id: selectedPayment?.id,
      paymentSolicitationStatus: statusPayment
        ? PaymentSolicitationStatus.PAID
        : PaymentSolicitationStatus.UNPAID,
      paymentDocument: attachment.file,
    };
    const formData = serialize(update, { indices: true });
    if (attachment.file) formData.append('paymentDocument', attachment.file);

    SolicitationController.updatePaymentStatus(formData)
      .then(() => {
        if (!selectedPayment?.id) return;
        setSolicitations((prev) => {
          const newSolicitations = [...prev];
          const solicitationsIdx = newSolicitations.findIndex(
            (s) => s.paymentId === selectedPayment.id,
          );
          if (solicitationsIdx !== -1) {
            newSolicitations[solicitationsIdx].payment.paymentSolicitationStatus =
              update.paymentSolicitationStatus;
            newSolicitations[solicitationsIdx].payment.paymentDocument = attachment.file;
          }
          setPayments((prevPayments) => {
            const newPayments = [...prevPayments];
            const paymentIdx = newPayments.findIndex((p) => p.id === selectedPayment.id);
            if (paymentIdx !== -1) {
              newPayments[paymentIdx].paymentStatus = update.paymentSolicitationStatus;
            }
            return newPayments;
          });

          return newSolicitations;
        });
        alert.show({ message: 'Documento anexado com sucesso!', type: 'success' });
        handleRequestClose();
      })
      .catch(() => {
        alert.show({ message: 'Erro ao anexar documento', type: 'error' });
      });
  };

  const handleFinalize = async () => {
    if (!solicitationId) return;
    const updateSolicitation: IUpdateSolicitationInputModel = {
      solicitationId,
      status: ServiceStatus.CONCLUED,
    };
    const formDataUpdate = serialize(updateSolicitation, { indices: true });
    await SolicitationController.updateStatus(formDataUpdate)
      .then(() => {
        const paymentId = selectedPayment?.id;
        setSolicitations((prev) => {
          const newSolicitations = [...prev];
          const solicitationsIdx = newSolicitations.findIndex((s) => s.id === solicitationId);
          if (solicitationsIdx !== -1) {
            newSolicitations[solicitationsIdx].status = updateSolicitation.status;
          }
          return newSolicitations;
        });
        refetchPayments();
        if (statusPayment) {
          const update: PaymentSolicitationUpdateInputModel = {
            id: paymentId,
            paymentSolicitationStatus: statusPayment
              ? PaymentSolicitationStatus.PAID
              : PaymentSolicitationStatus.UNPAID,
            paymentDocument: attachment?.file,
          };
          const formData = serialize(update, { indices: true });
          if (attachment?.file) formData.append('paymentDocument', attachment.file);

          SolicitationController.updatePaymentStatus(formData).then(() => {
            setSolicitations((prev) => {
              const newSolicitations = [...prev];
              const solicitationsIdx = newSolicitations.findIndex((s) => s.id === solicitationId);
              if (solicitationsIdx !== -1) {
                newSolicitations[solicitationsIdx].payment.paymentSolicitationStatus =
                  update.paymentSolicitationStatus;
                newSolicitations[solicitationsIdx].payment.paymentDocument = attachment?.file;

                setPayments((prevPayments) => {
                  const newPayments = [...prevPayments];
                  const paymentIdx = newPayments.findIndex(
                    (p) => p.solicitationId === newSolicitations[solicitationsIdx].id,
                  );
                  if (paymentIdx !== -1) {
                    newPayments[paymentIdx].paymentStatus = update.paymentSolicitationStatus;
                  }
                  return newPayments;
                });
              }
              return newSolicitations;
            });
            alert.show({ message: 'Solicitação finalizada com sucesso!', type: 'success' });
            handleRequestClose();
          });
        }
      })
      .catch(() => {
        alert.show({ message: 'Erro ao finalizar solicitação', type: 'error' });
      })
      .finally(() => handleRequestClose());
  };

  const handleRequestClose = () => {
    setShowError(false);
    onRequestClose();
  };

  const handleUpdateStatusCheckbox = (status: boolean) => {
    if (!attachment) return;
    if (!Object.keys(attachment).length && status) setShowError(true);
    else setStatusPayment(status);
  };

  useEffect(() => {
    if (selectedPayment?.paymentDocumentId && !attachment?.preview) {
      setIsLoading(true);
      Download(selectedPayment.paymentDocumentId)
        .then((file) => {
          const blob = new Blob([file], {
            type: selectedPayment.paymentDocument?.contentType,
          });
          setAttachment({
            id: selectedPayment.paymentDocumentId,
            file: new File([file], selectedPayment.paymentDocument?.name ?? 'Sem nome', {
              type: selectedPayment.paymentDocument?.contentType ?? '',
            }),
            preview: URL.createObjectURL(blob),
          });
        })
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, TIMER_LOADING);
        });
    }
  }, [attachment?.preview, selectedPayment]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-status-payment-modal-content">
      <Header>
        <div>
          <h1>
            {type === ModalPaymentType.UPDATE_PAYMENT ? (
              <>
                <IconDollar /> Status do pagamento
              </>
            ) : (
              <>
                <IconDollar /> Comprovante de pagamento
              </>
            )}
          </h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={handleRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <div className="container">
          <div className="containerStatus">
            <div className="contentStatus">
              <Checkbox
                checked={statusPayment}
                id="paid-out"
                onChange={() => handleUpdateStatusCheckbox(true)}
                disabled={statusPayment}
              />
              <label htmlFor="paid-out" className={statusPayment ? 'labelDisabled' : ''}>
                Pago
              </label>
            </div>
            <div className="contentStatus">
              <Checkbox
                checked={!statusPayment}
                id="unpaid"
                onChange={() => handleUpdateStatusCheckbox(false)}
                disabled={statusPayment}
              />
              <label htmlFor="unpaid" className={statusPayment ? 'labelDisabled' : ''}>
                Não pago
              </label>
            </div>
          </div>
        </div>
        <div className="containerAttachment">
          <div className="contentAttachment">
            <div>
              <h1>
                <IconPaperClip />
                {statusPayment ? 'Comprovante' : 'Anexar Comprovante'}
              </h1>
            </div>
            {isLoading ? (
              <div className="contentDropzone">
                <CircularProgress size={15} />
                <Typography
                  paddingLeft={1}
                  variant="caption"
                  color="text"
                  sx={{ fontStyle: 'italic' }}>
                  Carregando...
                </Typography>
              </div>
            ) : !attachment ? (
              <div className="contentDropzone">
                <DropZone
                  multipleFiles={false}
                  type="attachments"
                  onFile={(file) => {
                    setAttachment(file);
                    setStatusPayment(true);
                  }}
                />
              </div>
            ) : (
              <div className="contentDropzone">
                <Attachment
                  data={{
                    id: attachment.id,
                    type: attachment.file?.type ?? '',
                    name: attachment.file?.name ?? 'Sem nome',
                    uri: attachment.preview ?? undefined,
                  }}
                  options={{
                    disableDelete:
                      selectedPayment?.paymentSolicitationStatus === PaymentSolicitationStatus.PAID,
                  }}
                  onDelete={() => {
                    setAttachment(undefined);
                    setStatusPayment(false);
                  }}
                />
              </div>
            )}
          </div>
          {showError && (
            <p className="error">
              <ErrorIcon />
              Anexe o comprovante para atualizar o status de pagamento
            </p>
          )}
        </div>
        {/* <div className="CommentService">
          <span>Você quer deixar algum comentário sobre quem prestou o serviço?</span>
          <Controller
            control={control}
            name="Note"
            render={({ field: { value, onChange, ...rest } }) => (
              <textarea value={value} onChange={onChange} {...rest} className="Note" />
            )}
          />
        </div>
        <div className="starService">
          <div className="escrita">
            <text className="comment">Qual nota você daria para o prestador ?</text>
            <span>(0 estrela muito ruim, 5 estrelas muito bom)</span>
          </div>
          <div className="star">
            {items.map((item) => (
              <Star
                onClick={() => onClickStar(item)}
                key={`star_${item}`}
                isActive={item <= activeIndex!}
              />
            ))}
          </div>
        </div> */}
        <div className="content-buttons">
          {selectedPayment?.paymentSolicitationStatus === PaymentSolicitationStatus.PAID ? (
            <Button
              text="Confirmar"
              dimensions={{ width: '12rem', height: '2rem' }}
              font={{ size: '14' }}
              color="background_white"
              background="primary"
              backgroundHoverColor="tertiary_500"
              textHoverColor="background_white"
              onClick={handleRequestClose}
            />
          ) : (
            <>
              <Button
                text="Cancelar"
                dimensions={{ width: '12rem', height: '2rem' }}
                font={{ size: '14' }}
                color="background_white"
                background="primary"
                backgroundHoverColor="tertiary_500"
                textHoverColor="background_white"
                onClick={handleRequestClose}
              />
              {type === ModalPaymentType.UPDATE_PAYMENT ? (
                <Button
                  text="Confirmar"
                  dimensions={{ width: '12rem', height: '2rem' }}
                  font={{ size: '14' }}
                  color="background_white"
                  background="secondary"
                  backgroundHoverColor="tertiary_500"
                  textHoverColor="background_white"
                  border={{ color: 'primary' }}
                  onClick={handleUpdateStatus}
                />
              ) : (
                <Button
                  text="Finalizar"
                  dimensions={{ width: '12rem', height: '2rem' }}
                  font={{ size: '14' }}
                  color="background_white"
                  background="secondary"
                  backgroundHoverColor="tertiary_500"
                  textHoverColor="background_white"
                  border={{ color: 'primary' }}
                  onClick={handleFinalize}
                />
              )}
            </>
          )}
        </div>
      </ContentModal>
    </Modal>
  );
}
